module.exports = __webpack_public_path__ + "img/logo.335bea17.jpg";